import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const slides = [
  {
    id: 1,
    title: '原神',
    subtitle: '首儲雙倍優惠・限時加碼',
    description: '全新版本上線，首次儲值即享雙倍創世結晶回饋',
    image: 'https://public.readdy.ai/ai/img_res/44dda9d137558c484983ccb9cb56a0d9.jpg',
    gradient: 'from-sky-400/90 via-blue-500/80 to-indigo-600/90',
    cta: '立即儲值',
    link: '/order'
  },
  {
    id: 2,
    title: '崩壞：星穹鐵道',
    subtitle: '新角色限定UP・星瓊特惠',
    description: '限時活動進行中，儲值星瓊抽取全新五星角色',
    image: 'https://readdy.ai/api/search-image?query=Honkai%20Star%20Rail%20cosmic%20space%20scene%20with%20Astral%20Express%20train%20traveling%20through%20purple%20and%20blue%20galaxy%20nebula%20with%20bright%20stars%2C%20anime%20game%20characters%20in%20futuristic%20outfits%2C%20sci-fi%20atmosphere%20with%20glowing%20cosmic%20effects%2C%20professional%20game%20banner%20design%20with%20epic%20space%20exploration%20theme&width=1920&height=800&seq=hero2&orientation=landscape',
    gradient: 'from-purple-500/90 via-violet-600/80 to-indigo-700/90',
    cta: '立即儲值',
    link: '/order'
  },
  {
    id: 3,
    title: '絕區零',
    subtitle: '新版本上線・菲林限時折扣',
    description: '都市傳說再起，儲值菲林解鎖專屬角色與裝備',
    image: 'https://readdy.ai/api/search-image?query=Zenless%20Zone%20Zero%20urban%20cyberpunk%20city%20street%20at%20night%20with%20neon%20lights%20and%20holographic%20signs%2C%20anime%20game%20characters%20in%20stylish%20modern%20outfits%2C%20electric%20teal%20and%20purple%20color%20scheme%20with%20futuristic%20atmosphere%2C%20professional%20game%20banner%20design%20with%20dynamic%20urban%20exploration%20theme&width=1920&height=800&seq=hero3&orientation=landscape',
    gradient: 'from-teal-400/90 via-cyan-500/80 to-blue-600/90',
    cta: '立即儲值',
    link: '/order'
  },
  {
    id: 4,
    title: '鳴潮',
    subtitle: '開服慶典・潮汐加碼送',
    description: '全新開放世界冒險，儲值潮汐暢玩精彩內容',
    image: 'https://readdy.ai/api/search-image?query=Wuthering%20Waves%20fantasy%20world%20with%20mystical%20turquoise%20ocean%20waves%20and%20ancient%20ruins%2C%20anime%20game%20characters%20with%20magical%20powers%20and%20glowing%20effects%2C%20epic%20adventure%20atmosphere%20with%20water%20elements%20and%20bright%20sky%2C%20professional%20game%20banner%20design%20with%20magical%20exploration%20theme&width=1920&height=800&seq=hero4&orientation=landscape',
    gradient: 'from-teal-500/90 via-emerald-600/80 to-green-700/90',
    cta: '立即儲值',
    link: '/order'
  },
  {
    id: 5,
    title: 'PUBG Mobile',
    subtitle: '賽季通行證・UC超值優惠',
    description: '新賽季開啟，儲值UC解鎖專屬皮膚與道具',
    image: 'https://readdy.ai/api/search-image?query=PUBG%20Mobile%20battle%20royale%20scene%20with%20tactical%20soldiers%20in%20combat%20gear%20on%20desert%20battlefield%20with%20military%20vehicles%20and%20weapons%2C%20intense%20action%20atmosphere%20with%20smoke%20and%20sunset%20orange%20sky%2C%20professional%20game%20banner%20design%20with%20realistic%20warfare%20theme&width=1920&height=800&seq=hero5&orientation=landscape',
    gradient: 'from-orange-500/90 via-red-600/80 to-rose-700/90',
    cta: '立即儲值',
    link: '/order'
  },
  {
    id: 6,
    title: '英雄聯盟：激鬥峽谷',
    subtitle: '新英雄登場・聯盟幣特惠',
    description: '全新英雄上線，儲值聯盟幣解鎖造型與符文頁',
    image: 'https://readdy.ai/api/search-image?query=League%20of%20Legends%20Wild%20Rift%20epic%20MOBA%20battlefield%20with%20champion%20heroes%20in%20dynamic%20combat%20poses%20with%20magical%20effects%20and%20abilities%2C%20royal%20blue%20and%20gold%20color%20scheme%20with%20legendary%20atmosphere%2C%20professional%20game%20banner%20design%20with%20competitive%20gaming%20theme&width=1920&height=800&seq=hero6&orientation=landscape',
    gradient: 'from-blue-600/90 via-indigo-700/80 to-purple-800/90',
    cta: '立即儲值',
    link: '/order'
  }
];

export default function HeroSlider() {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const goToSlide = (index: number) => {
    setCurrentSlide(index);
  };

  return (
    <div className="relative h-[600px] overflow-hidden">
      {slides.map((slide, index) => (
        <div
          key={slide.id}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            index === currentSlide ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <div className="absolute inset-0">
            <img
              src={slide.image}
              alt={slide.title}
              className="w-full h-full object-cover object-top"
            />
            <div className={`absolute inset-0 bg-gradient-to-r ${slide.gradient}`}></div>
          </div>

          <div className="relative h-full max-w-7xl mx-auto px-6 flex items-center">
            <div className="text-white max-w-2xl">
              <h1 className="text-6xl font-bold mb-4">{slide.title}</h1>
              <p className="text-2xl font-semibold mb-3 text-yellow-300">{slide.subtitle}</p>
              <p className="text-lg mb-8 text-white/90">{slide.description}</p>
              
              <div className="flex items-center gap-4 mb-8">
                <div className="flex items-center gap-2 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full border border-white/30">
                  <i className="ri-shield-check-line text-lg"></i>
                  <span className="text-sm font-medium whitespace-nowrap">0 鎖號保證</span>
                </div>
                <div className="flex items-center gap-2 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full border border-white/30">
                  <i className="ri-flashlight-line text-lg"></i>
                  <span className="text-sm font-medium whitespace-nowrap">10 分鐘速儲</span>
                </div>
                <div className="flex items-center gap-2 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full border border-white/30">
                  <i className="ri-price-tag-3-line text-lg"></i>
                  <span className="text-sm font-medium whitespace-nowrap">全站 9 折優惠</span>
                </div>
              </div>

              <Link
                to={slide.link}
                className="inline-block bg-white text-gray-900 px-8 py-4 rounded-lg font-semibold text-lg hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
              >
                {slide.cta}
              </Link>
            </div>
          </div>
        </div>
      ))}

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex gap-3 z-10">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => goToSlide(index)}
            className={`w-3 h-3 rounded-full transition-all cursor-pointer ${
              index === currentSlide
                ? 'bg-white w-8'
                : 'bg-white/50 hover:bg-white/75'
            }`}
            aria-label={`前往投影片 ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
}